import { useEffect } from "react";
import { shallowEqual } from "react-redux";
import { getSessionStorageParams, getTaxLocationIdFromStorage } from "../utils/sessionStorage";
import type { CarConfigDispatchType } from "../redux/store";
import { useCarConfigSelector } from "../redux/store";
import { enableRegistrationTaxSelector } from "../utils/selectorUtils";
import { setExternalPriceTaxLocation } from "../redux/slices/carConfigExternalPriceSlice";
import { DEFAULT_TAX_LOCATION } from "../../../../common-deprecated/utils/taxLocations";
import { useDispatch } from "../../../../shared-logic/redux/store";

const useAphTaxInit = (): void => {
    const dispatch = useDispatch<CarConfigDispatchType>();
    const sessionStorageParams = useCarConfigSelector(getSessionStorageParams, shallowEqual);
    const enableRegistrationTax = useCarConfigSelector(enableRegistrationTaxSelector, shallowEqual);

    useEffect(() => {
        // SessionStorage will contain the taxLocationId if it has been manually set by the user.
        // If we don't already have a location ID (query string/tyCode/...) use that one.
        const sessionTaxLocationId = getTaxLocationIdFromStorage(sessionStorageParams);
        // Default to "75" as this is the value of Paris location
        if (enableRegistrationTax)
            dispatch(setExternalPriceTaxLocation({ locationId: sessionTaxLocationId || DEFAULT_TAX_LOCATION }));

        // Should only run once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export default useAphTaxInit;
